import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import { generateRecordKey } from "logic/logics";
import useOpenMeditationRecord from "./useOpenMeditationRecord";
import { MeditationGroupType } from "api/meditationRecordApi";

export default function useOpenNewMeditationRecord(
  groupType: MeditationGroupType = "routine"
) {
  const patientState = useRecoilValue(patientAtom);
  const newMeditationRecordKey = generateRecordKey(
    patientState?.patientId!!,
    "meditation"
  );
  const openNewMeditationRecord = useOpenMeditationRecord(
    newMeditationRecordKey,
    groupType
  );

  return openNewMeditationRecord;
}
